document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll('.flavor-button');
  const displayImage = document.getElementById('flavor-image');
  const displayWrapper = document.getElementById('custom-combine-list');
  const form = document.getElementById('flavor-cart-form');
  const variantIdInput = document.getElementById('variant-id');
  const flavorTitle = document.getElementById('flavor-title');
  const flavorDescription = document.getElementById('flavor-short-description');
  const flavorPrice = document.getElementById('flavor-price');
  const atcPrice = document.getElementById('atc-price');
  const qtyInput = document.getElementById('qty-input');
  const increaseBtn = document.getElementById('qty-increase');
  const decreaseBtn = document.getElementById('qty-decrease');
  const atcButton = document.getElementById('atc-button');
  const variantLabel = document.getElementById('variant-label');
  const qtyWrapper = document.getElementById('qty-wrapper');
  const learnMoreLink = document.getElementById('learn-more-link');

  const sweetLevel = document.getElementById('sweet-level');
  const spicyLevel = document.getElementById('spicy-level');
  const floralLevel = document.getElementById('floral-level');
  const freshLevel = document.getElementById('fresh-level');

  const sweetWrapper = sweetLevel?.parentElement;
  const spicyWrapper = spicyLevel?.parentElement;
  const floralWrapper = floralLevel?.parentElement;
  const freshWrapper = freshLevel?.parentElement;
  const flavorAttributes = document.getElementById('flavor-attributes');

  function hexToRgba(hex, alpha = 0.5) {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  function renderDots(container, level, activeColor) {
    container.innerHTML = '';
    for (let i = 1; i <= 5; i++) {
      const dot = document.createElement('span');
      dot.classList.add('dot');
      if (i <= level) {
        dot.classList.add('active');
        dot.style.backgroundColor = activeColor;
      }
      container.appendChild(dot);
    }
  }

  function updateStyles(btn) {
    const borderColor = btn.dataset.activeColor;
    const inactiveColor = btn.dataset.inactiveColor;
    const description = btn.dataset.description;

    const sweet = parseInt(btn.dataset.sweet || 0);
    const spicy = parseInt(btn.dataset.spicy || 0);
    const floral = parseInt(btn.dataset.floral || 0);
    const fresh = parseInt(btn.dataset.fresh || 0);

    const top = btn.dataset.top || '#ffffff';
const middle = btn.dataset.middle || '#fdf5dc';
const bottom = btn.dataset.bottom || '#ffffff';
displayWrapper.style.backgroundImage = `linear-gradient(180deg, ${top} 10%, ${middle} 50%, ${bottom} 90%)`;

    const anyHasValue = sweet > 0 || spicy > 0 || floral > 0 || fresh > 0;
    flavorAttributes.style.display = anyHasValue ? 'flex' : 'none';

    buttons.forEach(b => {
      const label = b.querySelector('p');
  b.classList.remove('active');
  b.style.backgroundColor = inactiveColor;
  b.style.borderColor = borderColor;
  if (label) {
    label.style.color = borderColor; // match inactive text color with active bg color
  }
    });

    btn.classList.add('active');
    const activeText = btn.querySelector('p');
if (activeText) {
  activeText.style.color = '#ffffff'; // or any contrasting color you want
}
    displayImage.src = btn.dataset.image;
    variantIdInput.value = btn.dataset.variantId;
    flavorTitle.textContent = btn.dataset.title;
    flavorDescription.innerHTML = description;
    flavorPrice.textContent = btn.dataset.price;
    atcPrice.textContent = btn.dataset.price;
    atcButton.style.backgroundColor = borderColor;
    flavorTitle.style.color = borderColor;
    // flavorDescription.style.color = borderColor;
    // variantLabel.style.color = borderColor;
    btn.style.backgroundColor = borderColor;
    btn.style.borderColor = borderColor;
    qtyWrapper.style.borderColor = borderColor;
    qtyInput.style.color = borderColor;
    increaseBtn.style.color = borderColor;
    decreaseBtn.style.color = borderColor;

    learnMoreLink.setAttribute('href', btn.dataset.url);
    learnMoreLink.style.backgroundColor = borderColor;
    learnMoreLink.style.color = '#ffffff';

    renderDots(sweetLevel, sweet, borderColor);
    renderDots(spicyLevel, spicy, borderColor);
    renderDots(floralLevel, floral, borderColor);
    renderDots(freshLevel, fresh, borderColor);
  }

  buttons.forEach(btn => {
    btn.addEventListener('click', function () {
      updateStyles(btn);
    });
  });

  if (buttons.length > 0) {
    updateStyles(buttons[0]);
  }

  increaseBtn.addEventListener('click', () => {
    qtyInput.value = parseInt(qtyInput.value) + 1;
  });

  decreaseBtn.addEventListener('click', () => {
    if (parseInt(qtyInput.value) > 1) {
      qtyInput.value = parseInt(qtyInput.value) - 1;
    }
  });

  // ✅ AJAX Add to Cart + Cart Drawer Integration
  form.addEventListener('submit', function (e) {
  e.preventDefault();

  const variantId = variantIdInput.value;
  const quantity = parseInt(qtyInput.value);

  if (!variantId) {
    alert("Please select a flavor.");
    return;
  }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({ id: variantId, quantity })
  })
    .then(res => res.json())
    .then(item => {
      console.log('✅ Added to cart:', item);

      const cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer) return;

      // ✅ Fetch latest drawer HTML (after item added)
      fetch('/?sections=cart-drawer')
        .then(res => res.json())
        .then(data => {
          const html = data['cart-drawer'];

          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const updatedDrawer = doc.querySelector('cart-drawer');

          if (updatedDrawer && cartDrawer.parentNode) {
            cartDrawer.parentNode.replaceChild(updatedDrawer, cartDrawer);

            // ✅ Now safe to open (no double animation)
            requestAnimationFrame(() => {
              if (typeof updatedDrawer.open === 'function') {
                updatedDrawer.open();
              } else {
                updatedDrawer.setAttribute('open', 'true');
              }
            });
          }
        });

      qtyInput.value = 1;
    })
    .catch(err => {
      console.error('❌ Add to cart error:', err);
      alert('Something went wrong. Please try again.');
    });
});
});